import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The DS defines custom font-size utilities in `@theme` (App.css). tailwind-merge
// doesn't know them, so by default it classifies `text-caption` etc. as text
// COLOR utilities — which then conflict with `text-ds-*` colors and get silently
// dropped depending on order. Register them under the font-size group so a size
// and a color can coexist on the same element.
//
// This list MUST mirror every `--text-*` token declared in App.css: a token that
// is missing here does not fail loudly, it silently drops the size or the
// colour wherever `cn()` sees it next to a text colour. `utils.test.ts` fails
// on a token App.css declares and this list lacks.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "caption",
            "desktop-article-title",
            "desktop-badge-meta",
            "desktop-badge-name",
            "desktop-body",
            "desktop-body-s",
            "desktop-caption",
            "desktop-card-title",
            "desktop-display",
            "desktop-h1",
            "desktop-h3",
            "desktop-heading",
            "desktop-hero",
            "desktop-meta",
            "desktop-overline",
            "desktop-step-title",
            "desktop-title",
            "footnote",
            "gpt-answer",
            "gpt-greeting",
            "gpt-greeting-desktop",
            "heading-display",
            "heading-lg",
            "heading-md",
            "heading-xs",
            "publication-lg",
            "ui-body",
            "ui-caption",
            "ui-highlight",
            "ui-note",
            "welcome-title",
          ],
        },
      ],
      // `--tracking-ds` in App.css, which would otherwise not replace a
      // `tracking-tight` it is merged over.
      tracking: [{ tracking: ["ds"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
